import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

type BulkTransitionBody = components["schemas"]["BulkTransitionRequest"];

/** POST /v1/promotions/bulk-transition. Invalidate, no optimism (spec §6). */
export function useBulkTransition() {
  const qc = useQueryClient();
  return useMutation({
    // Call site (PromotionsPage) already renders its own error UI (onErr);
    // suppress the global toast to avoid a duplicate raw-error message (TC58).
    meta: { silentError: true },
    mutationFn: async (body: BulkTransitionBody) => {
      const { data, error } = await apiClient.POST("/v1/promotions/bulk-transition", { body });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
